//Due to parcel urlEncoding links in nested includes we need to remove all &amp; from the links for them to work

const links = document.querySelectorAll('a[href]');
links.forEach(link => {
const href = link.getAttribute('href');
const decodedHref = href.replaceAll('&amp;', '&');
link.setAttribute('href', decodedHref);
});